"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryApi = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var CountryApi = /** @class */ (function (_super) {
    tslib_1.__extends(CountryApi, _super);
    function CountryApi(config) {
        return _super.call(this, config) || this;
    }
    // Load countries from location api - GET /api/danfoss-location/countries
    CountryApi.prototype.loadCountries = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.getData()];
            });
        });
    };
    // Load translated country from location api - GET /api/danfoss-location/countries?language={uk}
    CountryApi.prototype.loadTranslatedCountries = function (languageCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = {
                    language: languageCode,
                };
                return [2 /*return*/, this.getData(params)];
            });
        });
    };
    // Extended from BaseApi
    CountryApi.prototype.callApi = function (url, params) {
        var urlWithParams = this.buildUrl(url);
        return _super.prototype.callApi.call(this, urlWithParams, params);
    };
    CountryApi.prototype.buildUrl = function (url) {
        return "".concat(url).concat(CountryApi.API_PATH).replace(/([^:]\/)\/+/g, '$1');
    };
    CountryApi.COUNTRY_PREFIX = 'countryCode';
    CountryApi.API_PATH = '/danfoss-location/countries';
    return CountryApi;
}(app_1.BaseApi));
exports.CountryApi = CountryApi;
